import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/** org: hamkorlar (platforma), kompaniya profili (hamkor). */
export const workRoutes: RouteObject[] = [
  { path: 'sellers', ...page(() => import('./pages/SellersPage')) },
  { path: 'sellers/:id', ...page(() => import('./pages/SellerDetailPage')) },
];

export const sellerRoutes: RouteObject[] = [{ path: 'company', ...page(() => import('./pages/CompanyPage')) }];
